import { Editor } from '@tinymce/tinymce-react/lib/cjs/main/ts/components/Editor';
import React from 'react';

import { richTextEditorInnerStyle } from './RichTextEditorInner.css';

import './RichTextEditor.scss';


const editorConfig = {
	height: 300,
	menubar: false,
	plugins: [
		'lists', 'link', 'searchreplace', 'fullscreen', 'wordcount',
	],
	toolbar: 'undo redo | bold italic underline superscript subscript removeformat | ' +
		'bullist numlist link | searchreplace | fullscreen',
	content_style: richTextEditorInnerStyle,
};

interface Props {
	disabled?: boolean;
	value: string;
	onChange: (text: string) => void;
}

export function RichTextEditor({value, onChange, disabled}: Props) {
	return <Editor
		licenseKey='gpl'
		tinymceScriptSrc="/tinymce/tinymce.min.js"
		disabled={disabled}
		value={value}
		init={editorConfig}
		onEditorChange={onChange}
	/>;
}